import axios from "axios";
import firebase from "../../config/firebase";

export const getInstituteRequests =
  (lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let query = firebase
      .firestore()
      .collection("new-institute-requests")
      .orderBy("createdAt")
      .limit(5);
    if (lastDocument) {
      query = query.startAfter(lastDocument);
    }
    const unsubscribe = query.get().then(async (snapshot) => {
      let temp_data = [];
      for await (let doc of snapshot.docs) {
        temp_data.push({
          ...doc.data(),
          id: doc.id,
        });
      }
      dispatch({
        type: lastDocument ? "MORE_GET_ALL_REQUESTS" : "GET_ALL_REQUESTS",
        payload: {
          data: temp_data,
          hasMore: temp_data.length === 5,
          lastDocument:
            snapshot.docs.length > 0
              ? snapshot.docs[snapshot.docs.length - 1]
              : null,
        },
      });
      onComplete();
    });
    return unsubscribe;
  };

export const acceptRequest =
  (data, onComplete = () => {}) =>
  async () => {
    if (data.instituteLevel == "College") {
      let matchCity = await firebase
        .firestore()
        .collection("test-colleges-universities")
        .where("city", "==", data.city)
        .where("state", "==", data.state)
        .get();
      if (matchCity.empty) {
        let new_add = {
          city: data.city,
          institutes: [data.institute],
          state: data.state,
        };
        await firebase
          .firestore()
          .collection("test-colleges-universities")
          .add(new_add);
        firebase
          .firestore()
          .collection("new-institute-requests")
          .doc(data.id)
          .delete();
        onComplete();
      } else {
        firebase
          .firestore()
          .collection("test-colleges-universities")
          .doc(matchCity.docs[0].id)
          .update({
            institutes: firebase.firestore.FieldValue.arrayUnion(
              data.institute
            ),
          });
        firebase
          .firestore()
          .collection("new-institute-requests")
          .doc(data.id)
          .delete();
        onComplete();
      }
    } else {
      let matchCity = await firebase
        .firestore()
        .collection("test_schools")
        .where("county", "==", data.city)
        .where("state", "==", data.state)
        .get();
      if (matchCity.empty) {
        let new_add = {
          county: data.city,
          institutes: [data.institute],
          state: data.state,
        };
        firebase.firestore().collection("test_schools").add(new_add);
        firebase
          .firestore()
          .collection("new-institute-requests")
          .doc(data.id)
          .delete();
        onComplete();
      } else {
        firebase
          .firestore()
          .collection("test_schools")
          .doc(matchCity.docs[0].id)
          .update({
            institutes: firebase.firestore.FieldValue.arrayUnion(
              data.institute
            ),
          });
        firebase
          .firestore()
          .collection("new-institute-requests")
          .doc(data.id)
          .delete();
        onComplete();
      }
    }
    let athleteResponseEmailNew =
      "Your request for institute registration has been rejected.";
    const options = {
      to: data.email,
      subject: "Institute Registration Rejected",
      text: athleteResponseEmailNew,
    };
    axios.post(
      `${process.env.REACT_APP_FIREBASE_BASE_DOMAIN}/sendUserEmail`,
      options
    );
  };

export const rejectRequest =
  (data, onComplete = () => {}) =>
  () => {
    firebase
      .firestore()
      .collection("new-institute-requests")
      .doc(data.id)
      .delete();
    let athleteResponseEmailNew =
      "In FHP Platform Your request for institute registration has been rejected.";
    const options = {
      to: data.email,
      subject: "Institute Registration Rejected",
      text: athleteResponseEmailNew,
    };
    axios.post(
      `${process.env.REACT_APP_FIREBASE_BASE_DOMAIN}/sendUserEmail`,
      options
    );
    onComplete();
  };

export const sendAcceptanceEmail = (data) => () => {
  let athleteResponseEmailNew =
    "In FHP Platform Your request for institute registration has been accepted.";
  const options = {
    to: data.email,
    subject: "Institute Registration Accepted",
    text: athleteResponseEmailNew,
  };
  axios.post(
    `${process.env.REACT_APP_FIREBASE_BASE_DOMAIN}/sendUserEmail`,
    options
  );
};
